/** @jsx jsx */
// External Libraries
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import type { SerializedStyles } from '@emotion/core';
import { jsx } from '@emotion/core';
// @ts-expect-error TODO: type or globally ignore react-components
import { PageInfoMessage } from '@checkout/react-components';
import { infoMessageContainerOverrides, infoMessageOverrides } from './styles';
import type { IconType } from '../Spots/Icons/types';
import { isFunction } from '@/lib/utils/typeUtils';

interface StyleOverrides {
  container?: SerializedStyles;
  icon?: SerializedStyles;
  message?: SerializedStyles;
}

interface InfoMessagePropsWithoutIcon {
  message: ReactNode;
  testId: string;
  withoutIcon: true;
  styleOverrides?: StyleOverrides;
  logOnMount?: () => void;
  icon?: undefined | null;
  id?: string;
}

type InfoMessagePropsWith = Omit<
  InfoMessagePropsWithoutIcon,
  'withoutIcon' | 'icon'
> & {
  icon: IconType;
  withoutIcon?: false;
};

export const InfoMessage = ({
  icon,
  message,
  logOnMount,
  styleOverrides = {
    container: infoMessageContainerOverrides,
    message: infoMessageOverrides,
  },
  testId,
  withoutIcon,
  id,
}: InfoMessagePropsWithoutIcon | InfoMessagePropsWith): JSX.Element => {
  useEffect(() => {
    if (isFunction(logOnMount)) {
      logOnMount();
    }
  }, []);

  return (
    <PageInfoMessage
      icon={icon}
      testId={testId}
      message={message}
      styleOverrides={styleOverrides}
      withoutIcon={withoutIcon}
      id={id}
    />
  );
};
